export default __webpack_public_path__ + "static/media/030_corner_good.e779f83c.mp3";